export const policyOptions = [
  { label: 'Client-based', value: 'client' },
  { label: 'Group-based', value: 'group' },
  { label: 'Role-based', value: 'role' },
  { label: 'User-based', value: 'user' },
];
